import React from 'react';

import LoginForm from './components/LoginForm';

export const Login = () => <LoginForm />;
